import { render, staticRenderFns } from "./autoQuestion.vue?vue&type=template&id=e8b3d8ac"
import script from "./autoQuestion.vue?vue&type=script&lang=js"
export * from "./autoQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports